import {
  getIsDisableBagAnchoring,
  getIsPlpPdpAnchoringEnabled,
  getIsRedesignGlobalHeaderEnabled,
  getIsHeaderScrollViewDisabled,
} from '../reduxStore/selectors/session.selectors';
import {
  getLocalStorage,
  isMobileWeb,
  scrollPage,
  scrollToBreadCrumb,
  setLocalStorage,
} from './utils.web';

let isBackForwardPressed = false;

const getIsGlobalHeaderRedesignEnabled = (store) => {
  return getIsRedesignGlobalHeaderEnabled(store.getState());
};

const geIsHeaderScrollViewDisabled = (store) => {
  return getIsHeaderScrollViewDisabled(store.getState());
};

const getShouldScrollToBreadCrumb = (url, store) => {
  /*
       For Mobile web: scroll to breadcrumb if
       case1: visit plp or pdp or search without clicking back button with isPlpPdpAnchoringEnabled: true
       case2: visit bag page with isDisableBagAnchoring: false
  */
  if (isMobileWeb()) {
    const isPlpPdpAnchoringEnabled = getIsPlpPdpAnchoringEnabled(store.getState());
    const isDisableBagAnchoring = getIsDisableBagAnchoring(store.getState());
    const isPDP = url.includes('/p/') || url.includes('/b/') || url.includes('/outfit/');
    const isBagPage = url.includes('/bag');
    const isListingSearchOrPdp = url.includes('/c/') || isPDP || url.includes('/search/');
    const isGlobalHeaderRedesignEnabled = getIsGlobalHeaderRedesignEnabled(store) || false;
    const isHeaderScrollViewDisabled = geIsHeaderScrollViewDisabled(store) || false;

    return (
      (!isDisableBagAnchoring && isBagPage) ||
      (isPlpPdpAnchoringEnabled && !isBackForwardPressed && isListingSearchOrPdp) ||
      (isGlobalHeaderRedesignEnabled && isBagPage) ||
      (!isHeaderScrollViewDisabled && isBagPage)
    );
  }
  return false;
};

const getDoNoScrollForDesktop = (url) => {
  // Desktop: During PLP and SLP Actions return true to not perform any kind of scroll
  if (!isMobileWeb()) {
    const fromSBCCaraosal = url?.includes('viaModule=promoFilter');
    const previousUrl = getLocalStorage('previousUrl') || '';
    const [asPath] = url.split('?');
    const [previousAsPath] = previousUrl.split('?');
    const isActionDoneInsideSamePlpSlp =
      previousAsPath &&
      (previousAsPath.includes('/c') ||
        previousAsPath.includes('/search') ||
        previousAsPath.includes('/featurebrand')) &&
      previousAsPath.split('/')[3] === asPath.split('/')[3];
    return fromSBCCaraosal || isActionDoneInsideSamePlpSlp;
  }
  return false;
};

const handleRouteComplete = (url, store) => {
  const isPDP = url.includes('/p/') || url.includes('/b/') || url.includes('/outfit/');
  const isBagPage = url.includes('/bag');
  const shouldScrollToBreadCrumb = getShouldScrollToBreadCrumb(url, store);
  const isGlobalHeaderRedesignEnabled = getIsGlobalHeaderRedesignEnabled(store);
  const isHeaderScrollViewDisabled = geIsHeaderScrollViewDisabled(store);

  if (getDoNoScrollForDesktop(url)) {
    isBackForwardPressed = false;
    setLocalStorage({ key: 'previousUrl', value: url });
    return true;
  }
  if (shouldScrollToBreadCrumb) {
    scrollToBreadCrumb(
      isBagPage,
      isPDP,
      undefined,
      isGlobalHeaderRedesignEnabled,
      isHeaderScrollViewDisabled
    );
  } else if (!shouldScrollToBreadCrumb && !isBackForwardPressed) {
    const headerTopPromo = document.querySelector('.header-top-nav-promo-block');
    const headerTopNavBlock = document.querySelector('.header-top-nav-wrapper');
    const elementTag = isGlobalHeaderRedesignEnabled ? headerTopPromo : headerTopNavBlock;
    const scrollYIndex = elementTag?.getBoundingClientRect()?.height;

    // scroll to top of the page in case not a pdp,plp or search page and not browser back or forward click
    scrollPage(0, -scrollYIndex);
  }
  isBackForwardPressed = false;
  setLocalStorage({ key: 'previousUrl', value: url });
  return true;
};

const subscribeScrollRestore = (router, store) => {
  router.beforePopState(({ as }) => {
    // execute on browser back or forward
    if (as !== router.asPath) {
      isBackForwardPressed = true;
    }
    return true;
  });
  router.events.on('routeChangeComplete', (url) => handleRouteComplete(url, store));
};

const unSubscribeScrollRestore = (router) => {
  router.beforePopState(() => true);
  router.events.off('routeChangeComplete', handleRouteComplete);
};

export { subscribeScrollRestore, unSubscribeScrollRestore };
